module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai24-98c74a1a0b36fd709cc990c382f1285b.jpg";